import React from "react"

const loves = [
    "trees 🌴",
    "dinosaurs 🐉",
    "firetruck 🚒",
]
const AlexAge = ()=> (<span>
    {"the " + Math.floor(((new Date()) - (new Date(2020, 11, 14)))/(365.0*24.0*3600.0*1000.0)) }
    {`-years-old son loves ${loves[Math.floor(Math.random()*loves.length)]}`}
</span>)

export default AlexAge


